module.exports = require("/vercel/path0/.gatsby/gatsby-browser.ts");